const CartErrors = (props) => {
  const { cart } = props;
  if (!cart.errors) {
    return null;
  }
  if (cart.errors.length === 0) {
    return null;
  }
  return (
    <div className="c7-message--error">
      {cart.errors.map((error) => (
        <span key={error.message}>Error: {error.message}. </span>
      ))}
    </div>
  );
};

export default CartErrors;
